import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const ScreenStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      padding: 26px 0;
    }
  }

  .local-title {
    margin: 0 0 8px;
  }

  .local-subtitle {
    margin: 0 0 24px;
    padding: 0 16px;
  }
`;
